import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 101 剧情分歧
 */
export default class EventTextDif extends EventBase {
  eventLang: string | undefined
  langConfig: unknown

  constructor(param?: string[]) {
    super()
    if (param) {
      this.Parameter = param
    }
  }

  setLocalesParam(indexes: number[]): void {
    indexes = []
    const choiceTexts = this.TextDifChoice
    for (let i = 0; i < choiceTexts.length; i++){
      indexes.push(i)
    }
  }
  /**
   * 事件ID
   */
  Code = EventID.TextDif
  /**
   * 剧情选项
   */
  get TextDifChoice() {
    const list = new Array<string>()
    list.push(...(this.Parameter || []))
    return list
  }
  set TextDifChoice(value) {
    this.Parameter = value
  }

  /**
   * 获取描述信息
   */
  /// <returns></returns>
}
